import { render, staticRenderFns } from "./InspectionListItemSkeleton.vue?vue&type=template&id=7beca28e&scoped=true"
import script from "./InspectionListItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./InspectionListItemSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./InspectionListItemSkeleton.vue?vue&type=style&index=0&id=7beca28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beca28e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow,VSkeletonLoader})
